<template>
	<div>
		<div class="gd-searh__input-wrap">
			<input
				ref="search"
				type="text"
				class="gd-searh__input"
				placeholder="Search by address, suburb..."
			/>
			<button class="gd-searh__btn">
				<svg v-if="!loading">
					<use xlink:href="#icon-search-light"></use>
				</svg>
				<div v-else class="loader"></div>
			</button>
			<p v-if="nothingFound" class="gd-searh__not-found">{{ nothingFound }}</p>
			<div ref="info" class="d-none"></div>
		</div>
	</div>
</template>
<script>
	import getCategory from "../../mixins/getCategory";
	export default {
		name: "getCategory",
		mixins: [getCategory],
	};
</script>
